export const ICONS = {
  pending: "icon-alarm-fill",
  progress: "icon-money-fill",
  done: "icon-circle-done-fill",
};
